import { Button, Wrapper } from './styles'

interface ITab {
  key: string
  lable: string
}

interface IProps {
  currentKey: string
  handleClick: (key: string) => void
  tabs: ITab[]
}

export default function Tabs({ currentKey, tabs, handleClick }: IProps) {
  return (
    <Wrapper>
      {tabs.map(({ key, lable }) => (
        <Button key={key} onClick={() => handleClick(key)} active={currentKey === key}>
          {lable}
        </Button>
      ))}
    </Wrapper>
  )
}
